"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const calendar_svg_1 = __importDefault(require("../../../../../assets/icons/calendar.svg"));
const copyLinkIcon_svg_1 = __importDefault(require("../../../../../assets/icons/copyLinkIcon.svg"));
const download_svg_1 = __importDefault(require("../../../../../assets/icons/download.svg"));
const CopyLinkComponent_1 = require("../../../../../components/molecules/Popups/CopyLinkComponent");
const ExportDataComponent_1 = require("../../../../../components/molecules/Popups/ExportDataComponent");
const userStates_1 = require("../../../../../types/userStates");
const mapParamsHandler_1 = require("../../../../../utils/mapParamsHandler");
const measurementsCalc_1 = require("../../../../../utils/measurementsCalc");
const media_1 = require("../../../../../utils/media");
const thresholdColors_1 = require("../../../../../utils/thresholdColors");
const useScreenSizeDetection_1 = __importDefault(require("../../../../../utils/useScreenSizeDetection"));
const S = __importStar(require("../SessionDetailsModal.style"));
const ModalDesktopHeader = ({ streamShortInfo, thresholds, extremes, streamId, fixedSessionTypeSelected, }) => {
    const { currentUserSettings, searchParams } = (0, mapParamsHandler_1.useMapParams)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const isMobile = (0, useScreenSizeDetection_1.default)(media_1.screenSizes.largeDesktop);
    const newSearchParams = new URLSearchParams(searchParams.toString());
    const { minMeasurementValue, maxMeasurementValue, averageValue } = extremes;
    const min = minMeasurementValue !== null && minMeasurementValue !== void 0 ? minMeasurementValue : streamShortInfo.minMeasurementValue;
    const max = maxMeasurementValue !== null && maxMeasurementValue !== void 0 ? maxMeasurementValue : streamShortInfo.maxMeasurementValue;
    const avg = averageValue !== null && averageValue !== void 0 ? averageValue : streamShortInfo.averageValue;
    const noData = (0, measurementsCalc_1.isNoData)(min, max, avg) ||
        min === Infinity ||
        max === -Infinity ||
        min === -Infinity ||
        max === Infinity;
    newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.previousUserSettings, currentUserSettings);
    newSearchParams.set(mapParamsHandler_1.UrlParamsTypes.currentUserSettings, userStates_1.UserSettings.CalendarView);
    return (react_1.default.createElement(S.ModalDesktopHeader, null,
        react_1.default.createElement(S.Wrapper, null,
            react_1.default.createElement(S.SessionName, null, streamShortInfo.title),
            react_1.default.createElement(S.ProfileName, null, streamShortInfo.profile),
            react_1.default.createElement(S.SensorName, null, streamShortInfo.sensorName)),
        react_1.default.createElement(S.Wrapper, null,
            noData ? (react_1.default.createElement(S.NoData, null, t("sessionDetailsModal.noData"))) : (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(S.AverageValueContainer, null,
                    react_1.default.createElement(S.AverageDot, { "$color": (0, thresholdColors_1.getColorForValue)(thresholds, avg) }),
                    t("sessionDetailsModal.averageValue"),
                    react_1.default.createElement(S.AverageValue, null, avg),
                    streamShortInfo.unitSymbol),
                react_1.default.createElement(S.MinMaxValueContainer, { "$isMobile": false },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(S.SmallDot, { "$color": (0, thresholdColors_1.getColorForValue)(thresholds, min) }),
                        t("sessionDetailsModal.minValue"),
                        react_1.default.createElement(S.Value, null, min)),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(S.SmallDot, { "$color": (0, thresholdColors_1.getColorForValue)(thresholds, max) }),
                        t("sessionDetailsModal.maxValue"),
                        react_1.default.createElement(S.Value, null, max))))),
            react_1.default.createElement(S.TimeRange, null,
                streamShortInfo.startTime,
                " - ",
                streamShortInfo.endTime)),
        react_1.default.createElement(S.ButtonsContainer, null,
            fixedSessionTypeSelected && (react_1.default.createElement(S.BlueButton, { to: `/fixed_stream?streamId=${streamId}&${newSearchParams.toString()}` },
                isMobile ? "" : t("sessionDetailsModal.calendar"),
                react_1.default.createElement("img", { src: calendar_svg_1.default, alt: t("sessionDetailsModal.calendarIcon") }))),
            react_1.default.createElement(ExportDataComponent_1.ExportDataComponent, { button: react_1.default.createElement(S.Button, { "aria-labelledby": t("calendarHeader.altExportSession") },
                    react_1.default.createElement("img", { src: download_svg_1.default, alt: t("calendarHeader.altExportSession") })), fixedSessionTypeSelected: fixedSessionTypeSelected, sessionsIds: [streamShortInfo.sessionId], sensorName: streamShortInfo.sensorName, isIconOnly: true, onSubmit: (formData) => { }, isSessionList: false }),
            react_1.default.createElement(CopyLinkComponent_1.CopyLinkComponent, { button: react_1.default.createElement(S.Button, { "aria-label": t("copyLinkModal.altCopyLink") },
                    react_1.default.createElement("img", { src: copyLinkIcon_svg_1.default, alt: t("copyLinkModal.copyLink") })), isIconOnly: true }))));
};
exports.default = ModalDesktopHeader;
